import React from 'react';
import { BarGroup } from '@vx/shape';

import { useChartTooltipContext } from '../../../store/ChartTooltipContext';
import { BarChart, renderBar } from './barChart.component';
import { CHART_TYPES } from '../charts.constants';
import { BarsGroup } from './barChart.styles';

import { useIntl } from 'gatsby-plugin-intl';
const renderBarGroup = (isHoverActive, hoveredGroupIndex) => ({ index, x0, bars = [] }, key) => {
  const tooltip = useChartTooltipContext();
  const isGroupHovered = hoveredGroupIndex === key;

  const handleHover = (e) => {
    const barRect = e.target.getBoundingClientRect();
    const top = barRect.top + bars[0].height / 2;
    const left = barRect.left + bars[0].width / 2;

    if (left === tooltip.left && top === tooltip.top) {
      return;
    }

    tooltip.show({
      data: {
        bars,
        index: key,
      },
      index: key,
      top: top,
      left: left,
    });
  };

  return (
    <BarsGroup
      key={`bar-group-${index}-${x0}-${key}`}
      left={x0}
      isHoverActive={isHoverActive}
      isGroupHovered={isGroupHovered}
      {...tooltip.bindHoverEvents(handleHover)}
    >
      {bars.map((bar = {}, barIndex) => renderBar(bar, index, barIndex))}
    </BarsGroup>
  );
};

export const VerticalBarChart = ({ width, height, config, tabs, parser, data, showTooltip } = {}) => {
  const intl = useIntl();

  if (data.title) {
    data['title'] = intl.formatMessage({ id: data.title });
  }
  return (
    <BarChart
      width={width}
      height={height}
      config={config}
      chartData={data}
      renderBarGroup={renderBarGroup}
      type={CHART_TYPES.VERTICAL}
      groupingComponent={BarGroup}
      tabs={tabs}
      customParser={parser}
      showTooltip={showTooltip}
    />
  );
};
